<div class="slider-container">
  <div class="main-image-container">
    @for (item of mediaItems; track item; let i = $index) {
      <div
        class="main-image-item-wrapper"
        [style.display]="currentIndex === i ? 'block' : 'none'">
        @if (getThumbnailMediaItem(item)) {
          <sirius-image-item
            [image]="getThumbnailMediaItem(item)!"
            [imageData]="imageData"
            [autocrop]="false"
            fit="contain"
            (click)="openModal()"
            class="main-image"
            data-cy="main-image-item">
          </sirius-image-item>
        }
        @if (item.type === 'video') {
          <sirius-play-button
            (click)="openModal()"
            class="play-button">
          </sirius-play-button>
        }
      </div>
    }

    @if (mediaItems.length > 1) {
      <button
        siriusButton
        buttonType="linkstyle"
        size="small"
        iconName="caret_left"
        (click)="previous()"
        [disabled]="currentIndex === 0"
      class="nav-button nav-button--prev"></button>
    }

    @if (mediaItems.length > 1) {
      <button
        siriusButton
        buttonType="linkstyle"
        size="small"
        iconName="caret_right"
        (click)="next()"
        [disabled]="currentIndex === mediaItems.length - 1"
      class="nav-button nav-button--next"></button>
    }
  </div>

  <sirius-media-slider type="small" [items]="mediaItems" />

  <commerce-product-image-thumbnails
    [mediaItems]="mediaItems"
    [currentIndex]="currentIndex"
    [imageData]="imageData"
    (thumbnailClick)="setCurrentIndex($event)">
  </commerce-product-image-thumbnails>

  @if (open) {
    <sirius-media-collection-modal
      [items]="mediaItems"
      [startIndex]="currentIndex"
      (closeEvent)="onClose()"
      [showDescription]="showDescription">
    </sirius-media-collection-modal>
  }
</div>
